import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { AuthorizationService } from "../authorization/authorization.service";
import { WindowRef } from '../../utils/window';

import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  FormsModule,
  NgForm,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { RecaptchaLoaderService } from "../../utils/recaptchaLoader.service";
import { DTFHomepageService } from "../dtfhomepage/dtfhomepage.service";

import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { SessionTimeoutComponent } from "../sessionTimeout/sessionTimeout.component";

declare var grecaptcha: any;

@Component({
    selector: "div.dtf-dynamicleaseformpage",
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,SessionTimeoutComponent,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ],
    templateUrl: './dynamicleaseform.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class DynamicLeaseFormComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  isFrench = false;
  currentCountry: string;
  language = '';
  targetRedirect = '';
  env: string;
  usUrl: string;
  caUrl: string;
  checked = false;
  hasNumeric = false;
  phone ='';
  phoneLength = false;
  phoneValid =false;
  showPhoneErrors = false;

  form: FormGroup;
  ciamReCaptchaForm: FormGroup;
  insuranceForm: FormGroup;

  formValidationClasses = {
    'mbfs-error': true,
  };

  //Captcha
  rendered: any;
  captchaToggle = true;
  serviceErrorDesc = '';
  serviceErrorOccurred = false;
  environment = '';
  siteKeyCaptcha = '';
  recaptchaResponse = '';
  private recaptchaURL = APP_CONSTANTS.recaptchaURL;
  myForm: FormGroup;
  states: string[];
  counties: string[];


  country = new FormControl(null, [Validators.required]);
  state = new FormControl({ value: null, disabled: true }, [
    Validators.required,
  ]);
  county = new FormControl({ value: null, disabled: true }, [
    Validators.required,
  ]);

  

  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public translateUtil: TranslateUtil,
    public auth: AuthorizationService,
    public recaptchaLoaderService: RecaptchaLoaderService,
    public dtfhomepageService: DTFHomepageService,
    private fb: FormBuilder,
  ) {
    this.router = router;
      this.counties = [];
}

  ngOnInit() {
    this.getCaptcha();
    const language = (window as any).mbfs.language;
    this.env = (this._window.nativeWindow as any).mbfs.environment;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });

    this.getStates();  
    this.buildForm();
    this.onLoad();
  }

  onLoad(){
    this.selectSiteKey(); // used to set Site key based on environment
    //recaptcha script load
    if(this.language === 'fr-CA') {
      this.recaptchaURL = APP_CONSTANTS.recaptchaURLFR;
    } else {
      this.recaptchaURL = APP_CONSTANTS.recaptchaURL;
    }
    if (this.captchaToggle) {
    window['onloadCallback'] = this.onloadCallback.bind(this);
    window['getResponceCapcha'] = this.getResponceCapcha.bind(this);
    window['recaptchaResponseExpired'] = this.recaptchaResponseExpired.bind(this);
    window['recaptchaError'] = this.recaptchaError.bind(this);

    this.recaptchaLoaderService.loadScript(this.recaptchaURL)
        .then(data => {
        }).catch(error => console.log(error));
    }

    if (this.captchaToggle) {
      if (this.ciamReCaptchaForm.invalid) {
        this.translate.get('Errors.recaptcha').subscribe((data: any) => {
          this.serviceErrorDesc = data;
          return;
         });
      }
     }

     if (this.captchaToggle) {
      // const userRequest = {
      //   userId : this.userId,
      //   recaptcha : this.recaptchaResponse
      // };
      // this.getUser(userRequest);
     } else {
      // const userRequest = {
      //   userId : this.userId,
      //   recaptcha : 'false'
      // };
  }
}


onloadCallback() {
  this.rendered = grecaptcha.render('capcha_element', {
      'sitekey': this.siteKeyCaptcha,
      'lang': this.language
  });
}


getResponceCapcha(captchaResponse: string) {
  // this.verifyCaptcha(captchaResponse);
  this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(captchaResponse);
  (this._window.nativeWindow as any).scrollBy(0, 1);
  this.recaptchaResponse = this.ciamReCaptchaForm.controls.recaptchaResponseKey.value;
}

recaptchaResponseExpired() {
  this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(null);
  grecaptcha.reset(this.rendered);
}
recaptchaError() {
  this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(null);
  this.translate.get('Errors.recaptcha').subscribe((data: any) => {
    this.serviceErrorDesc = data;
   });
}

buildForm() {
  this.form = new FormGroup({
    country: this.country,
    state: this.state,
    county: this.county
  });

  this.insuranceForm = this.fb.group({
    first_name: [''],
    last_name: [''],
    company: [''],
    state: [''],
    county : [''],
    phone : [''],
    email : [''],
    dotnumber:  [''],
    renewaldate : [''],  
    powerunits : [''], 
    dynamicinsurance : [true],    
    cbdisclaimer: [false, Validators.requiredTrue]
  });

  this.ciamReCaptchaForm = this.fb.group({
    recaptchaResponseKey: [null, Validators.required]
});

}

public inputValidator(event: any) {
  this.showPhoneErrors = true;
  let phonevalue = event.target.value;
  this.hasNumeric = /^\d+$/.test(phonevalue);
  this.phoneLength = (phonevalue.length === 10);
  this.phoneValid = this.phoneLength && this.hasNumeric;
}

selectSiteKey() {
  this.environment = (this._window.nativeWindow as any).mbfs.environment;
  if (this.environment === 'local') {
   this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaLocal;
  } else if (this.environment === 'dev') {
    this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaDev;
  } else if (this.environment === 'stage') {
    this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaStage;
  } else if (this.environment === 'prod') {
    this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
  } else {
    this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
  }
}

getCaptcha() {
this.dtfhomepageService.getCaptcha().subscribe((res) => {
  this.captchaToggle = res;
});
}
getCounties() {
  this.county.reset();
  this.counties=[];
  const countyRequest = {
    "state_name" : this.state.value
   };
  this.auth.getCounties(countyRequest).subscribe((res) => {
    this.counties = res;
    this.county.enable();
  }); 
}

getStates() {
  this.states=[];
  this.county.disable();
  const stateRequest = {
   };
  this.auth.getStates(stateRequest).subscribe((res) => {
    this.states = res;
    this.state.enable();
  }); 
}

}
